import { createFileRoute, redirect } from '@tanstack/react-router'
import { getPreferredLang } from '@/hooks/useLang'

export const Route = createFileRoute('/tools/best-time-to-call')({
  beforeLoad: async () => {
    throw redirect({
      to: '/$lang/tools/best-time-to-call',
      params: { lang: await getPreferredLang() },
      replace: true,
    })
  },
})